import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { EstadoOrden } from "@/components/Atoms";
import { normSearch } from "@/lib/utils";
import { Plus, MagnifyingGlass } from "@phosphor-icons/react";

export default function Orders() {
    const { user } = useAuth();
    const [items, setItems] = useState([]);
    const [q, setQ] = useState("");
    const [estado, setEstado] = useState("");
    const canCreate = user?.role === "comercial" || user?.role === "supervisor";

    useEffect(() => { (async () => setItems((await api.get("/orders")).data))(); }, []);

    const filtered = items.filter(o => {
        if (estado && o.estado !== estado) return false;
        if (!q) return true;
        const s = normSearch(q);
        return [o.order_number, o.client?.razon_social, o.sistema_a_revisar, o.technician_cedula, o.norma_iso, o.fecha_programada]
            .some(v => normSearch(v).includes(s));
    });

    const title = user?.role === "tecnico" ? "Mis órdenes asignadas" : "Órdenes de servicio";

    return (
        <div className="max-w-7xl mx-auto p-4 md:p-8" data-testid="orders-page">
            <div className="flex items-end justify-between mb-8 border-b border-zinc-200 pb-6">
                <div>
                    <div className="overline mb-2">Operación</div>
                    <h1 className="font-display text-4xl font-black tracking-tighter">{title}</h1>
                </div>
                {canCreate && (
                    <Link to="/orders/new" className="btn-accent flex items-center gap-2" data-testid="new-order-link">
                        <Plus size={16} weight="bold" /> Crear orden
                    </Link>
                )}
            </div>

            <div className="grid md:grid-cols-[1fr_auto] gap-4 mb-6">
                <div className="relative">
                    <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
                    <input value={q} onChange={e => setQ(e.target.value)} placeholder="Buscar por número de orden, cliente, sistema…" className="input-atia pl-10" data-testid="orders-search" />
                </div>
                <div className="flex gap-0 border border-zinc-200">
                    {["", "pendiente", "en_curso", "cerrada"].map(v => (
                        <button key={v || "todas"} onClick={() => setEstado(v)} className={`px-4 py-2 text-xs font-bold uppercase tracking-wider border-r border-zinc-200 last:border-r-0 transition-colors ${estado === v ? "bg-zinc-900 text-white" : "bg-white hover:bg-zinc-50"}`} data-testid={`filter-estado-${v || "todas"}`}>
                            {v.replace("_", " ") || "Todas"}
                        </button>
                    ))}
                </div>
            </div>

            <div className="border border-zinc-200 overflow-x-auto">
                <table className="atia-table" data-testid="orders-table">
                    <thead><tr><th>N° Orden</th><th>Cliente</th><th>Sistema</th><th>Técnico CC</th><th>Norma</th><th>Fecha</th><th>Estado</th></tr></thead>
                    <tbody>
                        {filtered.length === 0 && <tr><td colSpan={7} className="text-center py-12 text-zinc-500">Sin órdenes.</td></tr>}
                        {filtered.map(o => (
                            <tr key={o.order_id} className="row-link" onClick={() => (window.location.href = `/orders/${o.order_id}`)} data-testid={`order-row-${o.order_id}`}>
                                <td className="font-mono text-xs font-semibold">{o.order_number}</td>
                                <td>{o.client?.razon_social || "—"}</td>
                                <td className="text-zinc-700 text-xs">{o.sistema_a_revisar}</td>
                                <td className="font-mono text-xs">{o.technician_cedula}</td>
                                <td className="text-zinc-600 text-xs">{o.norma_iso}</td>
                                <td className="font-mono text-xs text-zinc-500">{o.fecha_programada?.slice(0, 10)}</td>
                                <td><EstadoOrden estado={o.estado} /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
